import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ItemBase } from '../../../models/item/item-base';
import { AlertModalService } from '../../../component/alertmodal/alertmodal.service';
import { ReadonlyService } from '../readonly/readonly.service';
import { Select2ajaxService } from '../select/select2ajax.service';
import { ColumnBaseService } from '../base/columnbase.service';
var FormCopyComponent = /** @class */ (function () {
    function FormCopyComponent(baseService, alertModalService, readonlyService, s2Service) {
        this.baseService = baseService;
        this.alertModalService = alertModalService;
        this.readonlyService = readonlyService;
        this.s2Service = s2Service;
        this.componentName = '';
        this.colKey = '';
    }
    FormCopyComponent.prototype.ngOnInit = function () {
        this.colKey = this.baseService.getColKey(this.componentName, this.col.key, this.index);
    };
    FormCopyComponent.prototype.onClick = function (e) {
        e.stopPropagation();
        var copy = false;
        var copyText = this.getCopyText();
        if (window['clipboardData']) { // IE
            copy = window['clipboardData'].setData('Text', copyText);
        }
        else {
            var listener_1 = function (e) {
                e.clipboardData.setData('text/plain', copyText);
                e.preventDefault();
                document.removeEventListener('copy', listener_1);
            };
            document.addEventListener('copy', listener_1);
            copy = document.execCommand('copy');
        }
        if (copy) {
            this.alertModalService.open({
                message: this.msg['au.COMPONENT.FormCopyComponent.label.copy'],
                buttons: [],
                timeout: 600
            });
        }
    };
    FormCopyComponent.prototype.getCopyText = function () {
        var copyText = this.readonlyService.getValue(this.componentName, this.col, this.val, 'label');
        if (this.col.controlType === 'select2ajax' && this.val && !copyText) {
            var val = this.val;
            if (val && val.code) {
                val = val.code;
            }
            var option = this.s2Service.getOption(this.componentName, this.colKey);
            if (option && option.code && option.display && option.code === val) {
                copyText = option.display;
            }
        }
        return copyText;
    };
    FormCopyComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-copy',
                    template: '<a href="javascript:void(0);" [class.-ml-05]="key === \'listrow\'" (click)="onClick($event)"><img src="img/icon_copy.svg" alt="" width="18"></a>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    FormCopyComponent.ctorParameters = function () { return [
        { type: ColumnBaseService },
        { type: AlertModalService },
        { type: ReadonlyService },
        { type: Select2ajaxService }
    ]; };
    FormCopyComponent.propDecorators = {
        key: [{ type: Input }],
        componentName: [{ type: Input }],
        index: [{ type: Input }],
        col: [{ type: Input }],
        val: [{ type: Input }],
        msg: [{ type: Input }]
    };
    return FormCopyComponent;
}());
export { FormCopyComponent };
//# sourceMappingURL=copy.component.js.map